/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { AuthImageHeader, PrimaryButton, DocsOnboardCard, SecondaryButton } from '../components';
import { IDocuments, IDocumentsTypes } from '../interfaces';
import { GET_CLIENT_DOCUMENTS, GET_DOCUMENTS_TYPES } from '../graphql';
import { getToken, setToken } from '../services';

function AccountOnboarding(/* {}: AccountOnboardingProps */): React.ReactElement {
    const navigate = useNavigate();
    const { user, onBoarding } = getToken();
    const [documents, setDocuments] = useState<IDocuments[]>([]);
    const [documentTypes, setDocumentTypes] = useState<IDocumentsTypes[]>([]);
    const [uploading, setUploading] = useState<boolean>(false);
    const [showSkip, setShowSkip] = useState<boolean>(false);

    const { data: documentsData } = useQuery(GET_CLIENT_DOCUMENTS, {
        variables: { clientId: getToken()?.user?.id },
        fetchPolicy: 'network-only',
    });

    
    const { data: documentTypesData } = useQuery(GET_DOCUMENTS_TYPES, {
        variables: {clientId: getToken()?.user?.id},
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-argument
        if (documentsData?.getClientDocuments) {
            setDocuments(documentsData?.getClientDocuments);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            documentsData?.getClientDocuments.forEach((doc: IDocuments) => {
                if (doc.status !== 'COMPLETE') {
                    setShowSkip(true);
                }
                return true;
            });
        }
    }, [documentsData]);

    useEffect(() => {
        if (documentTypesData?.getDocumentTypes) {
            setDocumentTypes(JSON.parse(documentTypesData?.getDocumentTypes));
        }
    }, [documentTypesData]);

    useEffect(() => {
        if (!onBoarding) navigate('/');
    }, [onBoarding]);

    const handleSubmit = () => {
        const token = getToken();
        setToken({ ...token, onBoarding: false });
        navigate('/');
        navigate(0);
    };

    return (
        <div className="webkit-center">
            <AuthImageHeader topText="Account Onboarding" pageTile="Account Creation" breadCrumb="" />
            <Row className="justify-center margin-top-xl" style={{ marginTop: '20px' }}>
                <Col span="24">
                    <h1 className="margin-top-lg" style={{ fontSize: '28px', color: '#485460' }}>
                        Welcome to ReveNewCycle Management, {user?.firstName}
                    </h1>
                    <p style={{ fontSize: '14px', fontWeight: 'bold', width: '50%' }}>
                        As we get started on our journey together, we&apos;ll need a bit of information from you.
                        It&apos;s like fitting puzzle pieces together to give you the best service possible. Just a few
                        documents to sign and files to upload, and we&apos;ll be all set!
                    </p>
                </Col>
            </Row>
            <DocsOnboardCard documents={documents} documentTypes={documentTypes} getUploading={setUploading} />
            <Row className="justify-center margin-top-xl" style={{ marginBottom: '20px' }}>
                <div className="margin-right-sm">
                    {showSkip && <SecondaryButton title="SKIP" onClick={handleSubmit} />}
                </div>
                <div className="margin-left-sm">
                    <PrimaryButton title="COMPLETE" onClick={handleSubmit} disabled={uploading} />
                </div>
            </Row>
        </div>
    );
}

export default AccountOnboarding;
